import { render } from "./User.vue?vue&type=template&id=6bc6efa4&scoped=true&ts=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"

import "./User.vue?vue&type=style&index=0&id=6bc6efa4&lang=scss&scoped=true"
import "./User.vue?vue&type=style&index=1&id=6bc6efa4&scoped=true&lang=css"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc6efa4"]])

export default __exports__